module.exports = __webpack_public_path__ + "img/netProfitOrange.4760105b.png";